import { Phone } from "lucide-react";
import { Link } from "react-router-dom";
import { PHONE_TEL, PHONE_DISPLAY, ADDRESS_LINE1, ADDRESS_LINE2 } from "../../lib/site";
import { Reveal } from "./Reveal";
import { LEGAL_LINKS } from "./LegalFooter";

export const FinalCTA = () => (
  <>
    <section className="bg-red-700 py-20 sm:py-24 relative overflow-hidden" data-testid="final-cta-section">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
        <Reveal>
          <h2 className="font-heading text-5xl sm:text-6xl lg:text-7xl text-white tracking-tight leading-[0.98]">
            SCRAP PAYS.<br />WE PAY MORE.
          </h2>
          <p className="mt-6 text-red-100 text-lg font-medium max-w-xl mx-auto">
            Before you sell your metal, call Scrapman's for today's price.
          </p>
          <a href={PHONE_TEL} className="mt-8 block font-heading text-4xl sm:text-6xl text-white hover:text-zinc-950 transition-colors" data-testid="final-cta-phone">
            {PHONE_DISPLAY}
          </a>
          <a
            href={PHONE_TEL}
            className="mt-8 inline-flex items-center gap-3 bg-zinc-950 text-white px-10 py-4 font-heading text-xl tracking-wider hover:bg-white hover:text-zinc-950 transition-colors"
            data-testid="final-cta-call-button"
          >
            <Phone className="h-5 w-5" />
            CALL NOW
          </a>
        </Reveal>
      </div>
    </section>

    <footer className="bg-zinc-950 py-10 pb-24 lg:pb-10" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-4">
        <div className="flex items-center gap-3">
          <img src="/favicon.png" alt="Scrapman's mark" className="h-8 w-8" />
          <span className="font-heading text-white tracking-wide">SCRAPMAN'S METAL RECYCLING LLC</span>
        </div>
        <p className="text-zinc-500 text-sm">
          {ADDRESS_LINE1}, {ADDRESS_LINE2} · {PHONE_DISPLAY}
        </p>
      </div>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 mt-6">
        <nav className="flex flex-wrap gap-x-5 gap-y-2" data-testid="footer-legal-links">
          {LEGAL_LINKS.map((l) => (
            <Link
              key={l.to}
              to={l.to}
              className="text-xs font-semibold uppercase tracking-wider text-zinc-400 hover:text-white transition-colors"
              data-testid={`footer-link-${l.to.slice(1)}`}
            >
              {l.label}
            </Link>
          ))}
        </nav>
        <p className="text-[11px] leading-relaxed text-zinc-600 mt-6" data-testid="footer-credit">
          Website by{" "}
          <a
            href="https://webjesters.com/"
            target="_blank"
            rel="noopener noreferrer"
            className="text-zinc-500 underline underline-offset-2 hover:text-zinc-400 transition-colors"
            data-testid="footer-credit-link"
          >
            Webjesters
          </a>
        </p>
      </div>
    </footer>
  </>
);
